import React, { useRef, useEffect, useCallback } from 'react';
import { translate } from '../Services/translation';
import { useSelector, useDispatch } from 'react-redux';
import { toggle } from '../Actions/Cart.action';

const CartProductInfo = ({ item: { price, image, name, quantity } }) => {
  return (
      <div className="cart__product-info">
         <div className="cart__product image-container">
              {image && (<img className="cart__product image" alt={name} src={image} />)}
          </div>
      <div className="cart__product details">
        <div className="title-container">
          <p className="title">{name}</p>
          {quantity > 1 && <p className="quantity">x{quantity}</p>}
        </div>
        <p className="price">{price}</p>
      </div>
    </div>
  );
};

const MiniCart = () => {
  const dispatch = useDispatch();
  const cartRef = useRef(null);
  const {
    quantity,
    orderTotal,
    checkoutUrl,
    showInfo,
    orderRows,
  } = useSelector((state) => state.cart);

  const onToggle = useCallback(() => {
    dispatch(toggle());

    const bodyEl = document.querySelector('body');
    bodyEl.classList.toggle('navbar__mobile-menu--active');
  }, [dispatch]);

  useEffect(() => {
    if (!showInfo) return;

    const handleClickOutside = (event) => {
      if (cartRef.current && !cartRef.current.contains(event.target)) {
        onToggle();
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [showInfo, onToggle]);

  const hasItems = orderRows.length > 0;
  return (
    <div ref={cartRef} className={`cart cart--mini ${showInfo ? 'cart--mini--active' : ''}`}>
      <a
        className="cart__link--block"
        rel="nofollow"
        href="#"
        onClick={(e) => {
          e.preventDefault();
          // toggle cart
          onToggle();
        }}
      >
        <svg
          className="cart__link--icon"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.8711 5.05781C18.7837 4.94277 18.6709 4.84948 18.5414 4.78525C18.412 4.72101 18.2695 4.68756 18.125 4.6875H4.70547L4.02813 2.24922C3.97332 2.05179 3.85534 1.87775 3.69223 1.75373C3.52913 1.62972 3.3299 1.56255 3.125 1.5625H1.5625C1.31386 1.5625 1.0754 1.66127 0.899587 1.83709C0.723772 2.0129 0.625 2.25136 0.625 2.5C0.625 2.74864 0.723772 2.9871 0.899587 3.16291C1.0754 3.33873 1.31386 3.4375 1.5625 3.4375H2.4125L5.09219 13.0852C5.22122 13.5456 5.49709 13.9513 5.87785 14.2405C6.2586 14.5297 6.72341 14.6867 7.20156 14.6875H14.9219C15.4 14.6867 15.8648 14.5297 16.2456 14.2405C16.6263 13.9513 16.9022 13.5456 17.0312 13.0852L19.0336 5.87578C19.0715 5.73615 19.0765 5.58964 19.0483 5.44773C19.0201 5.30583 18.9595 5.17237 18.8711 5.05781ZM15.2188 12.5836C15.2007 12.6487 15.162 12.7062 15.1084 12.7475C15.0549 12.7888 14.9895 12.8116 14.9219 12.8125H7.2C7.13175 12.8124 7.06539 12.79 7.01108 12.7487C6.95676 12.7073 6.91748 12.6494 6.89922 12.5836L5.22656 6.5625H16.8914L15.2188 12.5836ZM8.4375 17.1875C8.4375 17.4965 8.34586 17.7986 8.17417 18.0556C8.00248 18.3125 7.75845 18.5128 7.47294 18.6311C7.18743 18.7493 6.87327 18.7803 6.57017 18.72C6.26708 18.6597 5.98867 18.5109 5.77015 18.2924C5.55163 18.0738 5.40281 17.7954 5.34252 17.4923C5.28223 17.1892 5.31318 16.8751 5.43144 16.5896C5.5497 16.304 5.74997 16.06 6.00692 15.8883C6.26387 15.7166 6.56597 15.625 6.875 15.625C7.2894 15.625 7.68683 15.7896 7.97985 16.0826C8.27288 16.3757 8.4375 16.7731 8.4375 17.1875ZM16.5625 17.1875C16.5625 17.4965 16.4709 17.7986 16.2992 18.0556C16.1275 18.3125 15.8835 18.5128 15.5979 18.6311C15.3124 18.7493 14.9983 18.7803 14.6952 18.72C14.3921 18.6597 14.1137 18.5109 13.8951 18.2924C13.6766 18.0738 13.5278 17.7954 13.4675 17.4923C13.4072 17.1892 13.4382 16.8751 13.5564 16.5896C13.6747 16.304 13.875 16.06 14.1319 15.8883C14.3889 15.7166 14.691 15.625 15 15.625C15.4144 15.625 15.8118 15.7896 16.1049 16.0826C16.3979 16.3757 16.5625 16.7731 16.5625 17.1875Z"
            fill="currentColor"
          />
        </svg>
        <span className="cart__quantity">{quantity > 9 ? '9+' : quantity}</span>
        <span className="cart__title hide">
          {translate('minicart.checkout')}
        </span>
      </a>
      <div className={`cart__info ${!showInfo ? 'cart__info--hidden' : ''}`}>
        <div className="cart__products-wrapper">
          {hasItems ? (
            orderRows.map((item) => (
              <CartProductInfo key={item.articleNumber} item={item} />
            ))
          ) : (
            <p> {translate('minicart.empty')}</p>
          )}
        </div>

        <p className="cart__info-row">
          <b>{translate('minicart.total')}</b>
          <span>{orderTotal}</span>
        </p>

        <div className="cart__checkout-wrapper">
          <a href={checkoutUrl} className="cart__checkout-button">
            {translate('minicart.checkout')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default MiniCart;
